module.exports = __webpack_public_path__ + "static/media/portrait.6d9eab1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/portrait.png
// module id = 797
// module chunks = 0